import { sdkService } from 'services'
import { useSyncExternalStore } from 'use-sync-external-store/shim'

export const useSdk = () => {
  const subscribe = (listener: any) => {
    const handleService = (_partial: any) => {
      listener()
    }
    sdkService.subscribe(handleService)
    return () => sdkService.unsubscribe(handleService)
  }

  const getSnapshot = () => sdkService.getState()
  const { orgs, members } = useSyncExternalStore(subscribe, getSnapshot)

  return { orgs, members }
}
